import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Drawer from "@material-ui/core/Drawer";
import SidenavContent from "./SidenavContent";
import ApplicantMenuList from "./ApplicantMenuList";
import AdminMenuList from "./AdminMenuList";
import StudentMenuList from "./StudentMenuList";
import UserInfo from "components/UserInfo";
import { COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION } from "constants/ActionTypes";
import { toggleCollapsedNav, updateWindowWidth } from "actions/Setting";
import { withStyles } from "@material-ui/core";
import AlumniMenuList from "./AlumniMenuList";

const styles = (theme) => ({
  root: {
    width: "260px",
  },
});
class SideNav extends React.Component {
  onToggleCollapsedNav = (e) => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.props.updateWindowWidth(window.innerWidth);
    });
  }

  render() {
    const { navCollapsed, drawerType, width, navigationStyle, userMode, authUser } = this.props;
    let drawerStyle = drawerType.includes(FIXED_DRAWER) ? "d-xl-flex" : drawerType.includes(COLLAPSED_DRAWER) ? "" : "d-flex";
    let type = "permanent";
    if (drawerType.includes(COLLAPSED_DRAWER) || (drawerType.includes(FIXED_DRAWER) && width < 1200)) {
      type = "temporary";
    }

    if (navigationStyle === HORIZONTAL_NAVIGATION) {
      drawerStyle = "";
      type = "temporary";
    }
    return (
      <div className={`app-sidebar d-none ${drawerStyle}`}>
        <Drawer
          className={`app-sidebar-content`}
          variant={type}
          open={type.includes("temporary") ? navCollapsed : true}
          onClose={this.onToggleCollapsedNav}
          classes={{
            paper: `side-nav ${this.props.classes.root}`,
          }}
        >
          <UserInfo user={this.props.authUser} userMode={userMode} />
          {userMode === "Applicant" && <ApplicantMenuList user={authUser} />}
          {userMode === "Alumni" && <AlumniMenuList user={authUser} />}
          {userMode === "Admin" && <AdminMenuList pages={this.props.pages} />}
          {userMode === "Student" && <StudentMenuList studentPages={this.props.studentPages} />}
          {userMode === "app" && <SidenavContent />}
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { navCollapsed, drawerType, width, navigationStyle } = settings;
  const { pages, authUser, studentPages } = auth;
  return { navCollapsed, drawerType, width, navigationStyle, pages, studentPages };
};

export default withRouter(connect(mapStateToProps, { toggleCollapsedNav, updateWindowWidth })(withStyles(styles)(SideNav)));
